import { SvgIcon, type SvgIconProps } from "@mui/material";
import { type FC, type PropsWithChildren } from "react";

const Dashboard: FC<PropsWithChildren<SvgIconProps>> = (props) => (
    <SvgIcon {...props} viewBox="0 0 16 16">
        <path
            fillRule="evenodd"
            d="M14.5454545,2 L1.45454545,2 L1.45454545,11 L14.5454545,11 L14.5454545,2 Z M16,2 L16,11 C16,11.8284271 15.3487778,12.5 14.5454545,12.5 L9.45454545,12.5 L9.45454545,14 L10.9090909,14 L10.9090909,15.5 L5.09090909,15.5 L5.09090909,14 L6.54545455,14 L6.54545455,12.5 L1.45454545,12.5 C0.647272727,12.5 0,11.825 0,11 L0,2 C0,1.1675 0.647272727,0.5 1.45454545,0.5 L14.5454545,0.5 C15.3487778,0.5 16,1.17157288 16,2 Z M9.45454545,3.5 L9.45454545,7.25 L2.90909091,7.25 L2.90909091,3.5 L9.45454545,3.5 Z M13.0909091,3.5 L13.0909091,5 L10.1818182,5 L10.1818182,3.5 L13.0909091,3.5 Z M13.0909091,9.5 L10.1818182,9.5 L10.1818182,5.75 L13.0909091,5.75 L13.0909091,9.5 Z M5.81818182,8 L5.81818182,9.5 L2.90909091,9.5 L2.90909091,8 L5.81818182,8 Z M6.54545455,8 L9.45454545,8 L9.45454545,9.5 L6.54545455,9.5 L6.54545455,8 Z"
        />
    </SvgIcon>
);

export default Dashboard;
